<div class="modal-header modal-pepsico-header">
  <h1 class="modal-title fs-5" id="exampleModalLabel">{{ challenge()?.name | uppercase }}</h1>
</div>

<div class="modal-body">

  <!-- ===== PASO 1: ARCHIVO (Image / Mixed / Permanent) ===== -->
  @if (requiresFile() && step() === 1) {

    <p class="foto-tutorial-txt mt-3">
      <b>Carga una foto de tu exhibición en los siguientes formatos.</b><br />
      <small>Solo participará una exhibición por tienda.</small>
    </p>

    <div class="upload-pic">
      <img
        [src]="previewSrc()"
        alt="Archivo actual"
        class="preview-image img-info-mis-foto mt-3"
        (click)="openFilePicker()"
      />

      <input
        #fileInput
        type="file"
        class="file-upload"
        accept="image/*,video/*,application/pdf"
        hidden
        (change)="onFileSelected($event)"
      />

      <p class="format-hint hint-text" *ngIf="showFormatHint()">
        Formato: Imagen, Video, PDF. <br />
        Peso máximo de archivo 12 MB.
      </p>

      <p class="upload-hint hint-text" *ngIf="showUploadHint()">
        Si deseas cambiar tu imagen, da clic sobre la imagen de arriba para seleccionar una nueva.
      </p>
    </div>

    <div class="order-tracking-unique mt-3">
      <div class="d-flex jf-center gap-2">
        <button type="button" class="btn btn-primary perfilbtn-pep hw-modal-par" (click)="dismiss()">
          Cerrar
        </button>

        <button
          type="button"
          class="btn btn-primary perfilbtn-pep hw-modal-par"
          [disabled]="sending() || !selectedFile()"
          (click)="uploadFileAndContinue()"
        >
          {{ sending() ? 'Subiendo...' : (isMixed() ? 'Continuar' : 'Enviar') }}
        </button>
      </div>
    </div>
  }

  <!-- ===== PASO 2: QUIZ (Mixed / Survey / Satisfaction) ===== -->
  @if (requiresQuiz() && step() === 2) {

    <div class="comment-reactions-tabs-unique">
      <span><b>Por favor responde las siguientes preguntas.</b><br /></span>
    </div>

    @if (loadingQuiz()) {
      <p class="mt-3">Cargando preguntas...</p>
    } @else {

      @if (!quiz().length) {
        <p class="mt-3">No se encontraron preguntas para este desafío.</p>
      } @else {

        @if (currentQuestion(); as q) {

          <div class="row justify-content-center mt-3">
            <div class="col-md-12">
              <div class="form-group">

                <label class="form-control-label">
                  {{ currentIndex() + 1 }} / {{ displayQuiz().length }} - {{ q.description }}
                </label>

                <!-- abierta -->
                @if (q.isOpen) {
                  <div class="input-with-icon">
                    <textarea
                      class="form-control"
                      rows="3"
                      [value]="getOpenAnswerValue(q.questionId)"
                      (input)="setOpenAnswer(q.questionId, $any($event.target).value)">
                    </textarea>
                  </div>
                }
                <!-- cerrada -->
                @else {
                  <div class="input-with-icon">
                    <select
                      class="custom-select form-select"
                      [value]="getClosedAnswerValue(q.questionId)"
                      (change)="setClosedAnswer(q.questionId, $any($event.target).value)">
                      <option value="">Selecciona una opción</option>
                      @for (a of q.answers; track a.answerId) {
                        <option [value]="a.answerId">{{ a.description }}</option>
                      }
                    </select>
                  </div>
                }

              </div>
            </div>
          </div>

          <div class="order-tracking-unique mt-3">
            <div class="d-flex jf-center gap-2">
              <button type="button" class="btn btn-primary perfilbtn-pep hw-modal-par" (click)="dismiss()">
                Cerrar
              </button>

              @if (!isLastQuestion()) {
                <button
                  type="button"
                  class="btn btn-primary perfilbtn-pep hw-modal-par"
                  [disabled]="sending()"
                  (click)="nextQuestion()"
                >
                  Continuar
                </button>
              } @else {
                <button
                  type="button"
                  class="btn btn-primary perfilbtn-pep hw-modal-par"
                  [disabled]="sending()"
                  (click)="submitFinal()"
                >
                  {{ sending() ? 'Enviando...' : 'Enviar' }}
                </button>
              }
            </div>
          </div>
        }
      }
    }
  }
</div>
